import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

import { IYearMonth } from '@/coreDomainsModule/date';
import { ForecastAccuracyHeaderKey, TableContentProperty } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';
import { TableContentItem } from '@/corePagesModule/BaseTableContent/interface/tableContentItems';
import TableCell from '@/corePagesModule/BaseTableContent/components/TableCell.vue';
import { ForecastAccuracyTableContentViewModel } from './forecastAccuracyTableContentViewModel';
import ForecastAccuracyRowMenu from './ForecastAccuracyRowMenu.vue';
import { computed } from 'vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastAccuracyTableCell',
  props: {
    header: {},
    headerKey: {},
    item: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isVariableWidth: { type: Boolean },
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isBold: { type: Boolean },
    forecastStartYearMonth: { default: undefined },
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean }
  },
  emits: ["onClickNarrow", "onClickDownload"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

const forecastAccuracyTableContentVM = new ForecastAccuracyTableContentViewModel();

const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

/**
 * メニュー選択時の処理
 * @param option - 選択したオプション
 */
const onSelectMenu = (option: 'download') => {
  if (option === 'download') {
    emits('onClickDownload', props.item.displayId);
  }
};

return (_ctx: any,_cache: any) => {
  return (_ctx.headerKey === 'ForecastAccuracyMenu')
    ? (_openBlock(), _createBlock(TableCell, {
        key: 0,
        class: _normalizeClass([[_unref(forecastAccuracyTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : ''], "table-cell base-table__body--fixed"]),
        style: _normalizeStyle({
      left: _unref(forecastAccuracyTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
        "text-align": "center",
        "table-content-property": _ctx.header,
        "is-highlighted": props.isChecked || props.isCheckedBusinessId
      }, {
        default: _withCtx(() => [
          _createVNode(ForecastAccuracyRowMenu, { onSelect: onSelectMenu })
        ], undefined, true),
        _: 1
      }, 8, ["class", "style", "table-content-property", "is-highlighted"]))
    : (_openBlock(), _createBlock(TableCell, {
        key: 1,
        class: _normalizeClass([[_unref(forecastAccuracyTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : ''], "table-cell base-table__body--fixed"]),
        style: _normalizeStyle({
      left: _unref(forecastAccuracyTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
        "text-align": textAlign.value,
        "table-content-property": _ctx.header,
        "tool-tip-value": _unref(forecastAccuracyTableContentVM).displayForecastAccuracyItem(_ctx.headerKey, _ctx.item, _ctx.forecastStartYearMonth),
        "is-highlighted": props.isChecked || props.isCheckedBusinessId
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass(["table-cell-content", { 'table-cell-content--bold': _ctx.isBold }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickNarrow')))
          }, _toDisplayString(_unref(forecastAccuracyTableContentVM).displayForecastAccuracyItem(_ctx.headerKey, _ctx.item, _ctx.forecastStartYearMonth)), 3)
        ], undefined, true),
        _: 1
      }, 8, ["class", "style", "text-align", "table-content-property", "tool-tip-value", "is-highlighted"]))
}
}

})